import React, { Suspense, lazy } from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

const Navbar1 = lazy(() => import('./Component/Navbar1/Navbar1'));
const Abouts = lazy(() => import('./Pages/Abouts/Abouts'));
const Blog = lazy(() => import('./Pages/Blog/Blog'));
const Projects = lazy(() => import('./Pages/Projects/Projects'));
const Speaking = lazy(() => import('./Pages/Speaking/Speaking'));
const Toolbox = lazy(() => import('./Pages/Toolbox/Toolbox'));

const App = () => {
  return (
    <Router>
      <Suspense fallback={<div className="p-4 text-center">Loading...</div>}>
        <Routes>
          <Route path="/" element={<Navigate to="/home" />} />
          <Route path="/home" element={<Navbar1 category="Home" />} />
          <Route path="/about" element={<Abouts category="About" />} />
          <Route path="/blog" element={<Blog category="Blog" />} />
          <Route path="/project" element={<Projects category="Project" />} />
          <Route path="/speaking" element={<Speaking category="Speaking" />} />
          <Route path="/toolbox" element={<Toolbox category="Toolbox" />} />
        </Routes>
      </Suspense>
    </Router>
  );
};

export default App;


